import { Component, OnInit, Input } from "@angular/core";
import { ThemeService } from "src/app/theme.service";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import {
  faTwitter,
  faFacebookF,
  faGithubAlt,
  faInstagram,
  faYoutube,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import { DataService, HomeLink } from "src/app/data.service";

@Component({
  selector: "app-home-contact",
  templateUrl: "./home-contact.component.html",
  styleUrls: ["./home-contact.component.css"],
})
export class HomeContactComponent implements OnInit {
  @Input() navigate;
  faEnvelope = faEnvelope;
  faTwitter = faTwitter;
  faFacebookF = faFacebookF;
  faGithubAlt = faGithubAlt;
  faInstagram = faInstagram;
  faYoutube = faYoutube;
  faLinkedinIn = faLinkedinIn;
  home_links: Array<HomeLink> = [];

  constructor(
    public themeService: ThemeService,
    dataService: DataService
  ) {
    this.home_links = dataService.home_links.filter((element) => {
      return element.href.search("contact@tanaytoshniwal.me") === -1;
    });
  }

  ngOnInit(): void {}
}
